import { CellClassParams, CellStyle } from "ag-grid-community";

export function numberCellStyle(params: CellClassParams): CellStyle {
  if (params?.value < 0) {
    return { color: "red", textAlign: "right" };
  } else {
    return { color: "black", textAlign: "right" };
  }
}
